import React, { FC } from "react";
import { TablePagination as MuiTablePagination } from "@mui/material";

type Props = React.ComponentProps<typeof MuiTablePagination>;

const TablePagination: FC<Props> = (props) => {
    return <MuiTablePagination {...props}/>
}

export default TablePagination;